import React, { useContext, useEffect, useState } from "react";
import { Card, Label, ModalBody, Badge } from "reactstrap";
import {
  Button,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Col,
  Row,
  OverlineTitle,
  Sidebar,
  UserAvatar,
} from "../../../components/Component";
import InputMask from 'react-input-mask';
import { useHistory } from "react-router";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { currentTime, domainPattern, findUpper, formDataUsername, indianNumRegex, ipPattern, monthNames, nameRegex, tenantAddEditData, todaysDate, usaNumRegex, usaNumRegex2 } from "../../../utils/Utils";
import { UserContext } from "../user-manage/UserContext";
import { notes } from "../user-manage/UserData";
import Api from "../../../Api";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import moment from "moment-timezone";


const AddTenant = ({ match }) => {
  const [tenantDetailState, setTenantDetail] = useState(
    {
      name: "",
      organizationName: "",
      contactName: "",
      firstName: "",
      middleName: "",
      lastName: "",
      emailId: "",
      streetAddress: "",
      city: "",
      state: "",
      zip: "",
      timeZone: "",
      country: "USA",
      createdBy: formDataUsername(),
      phoneNo: "",
      hostUrl: "",
      hostIp: "",
      tenantHost: [
        {
          hostUrl: "https://localhost:44365", // textbox
          hostIp: "192.168.1.41",
          createdBy: formDataUsername(),
          isActive: true
        }
      ],
      "tenantLicense": [
        {
          serviceStartDate: new Date(Date?.now()),
          createdBy: formDataUsername(),
        }
      ],
      "tenantPhone": [
        {
          phoneNo: "",
          createdBy: formDataUsername()
        }
      ],
    }
  );

  const { contextData } = useContext(UserContext);
  const [data] = contextData;

  const [sideBar, setSidebar] = useState(false);
  const [user, setUser] = useState();
  const [noteData, setNoteData] = useState(notes);
  const [addNoteModal, setAddNoteModal] = useState(false);
  const [addNoteText, setAddNoteText] = useState("");
  const history = useHistory();
  const [error, setError] = useState({
    name: "",
    organizationName: "",
    contactName: "",
    firstName: "",
    lastName: "",
    streetAddress: "",
    city: "",
    country: "",
    state: "",
    zip: "",
    emailId: "",
    timeZone: "",
    PhoneType: "",
    phoneNo: "",
    hostIp: "",
    hostUrl: "",
    middleName: "",
    somethingWentWring: "",
  });

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [regexs, setRegexs] = useState({
    // name: /^[a-zA-Z0-9]+$/,
    name: /^(?=.*[A-Za-z])[\w\s.]+$/,
    email: /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/,
    // phone: /^\(\+1\) \d{3} \d{3} \d{4}$/,
    phone: /^\(\d{3}\) \d{3}-\d{4}$/,
    // zip: /^\d{5,10}$/,
    zip: /^\d{5}$/,
    streetAddress: /^.{5,}$/,
  });

  const [timezones, setTimezones] = useState([]);

  const getCountrylistStateList = async () => {
    try {
      let list = await Api.GetAdminCountryList();
      setCountryList(list);
      let list2 = await Api.GetAdminState(list[0]?.countryId);
      setStateList(list2)
      setTenantDetail({ ...tenantDetailState, country: list[0]?.countryId, state: list2[0]?.stateId + " " + list2[0]?.countryId });
    } catch (error) {
    }
  }

  useEffect(() => {
    getCountrylistStateList();
    const allTimezones = moment.tz.names();
    const timezonesData = allTimezones.map((timezone) => {
      const offset = moment.tz(timezone).format("Z"); // Get timezone offset in ±HH:mm format
      const gmtOffset = `(GMT${offset})`;
      const timezoneName = timezone.replace(/_/g, ' '); // Replace underscores with spaces
      return `${gmtOffset} ${timezoneName}`;
    });

    setTimezones(timezonesData);
  }, [])

  // grabs the id of the url and loads the corresponding data
  useEffect(() => {
    const id = match.params.id;
    if (id !== undefined || null || "") {
      let spUser = data.find((item) => item.id === Number(id));
      setUser(spUser);
    } else {
      setUser(data[0]);
    }
  }, [match.params.id, data]);

  // function to toggle sidebar
  const toggle = () => {
    setSidebar(!sideBar);
  };

  // delete a note
  const deleteNote = (id) => {
    let defaultNote = noteData;
    defaultNote = defaultNote.filter((item) => item.id !== id);
    setNoteData(defaultNote);
  };

  const submitNote = () => {
    let submitData = {
      id: Math.random(),
      text: addNoteText,
      date: `${monthNames[todaysDate.getMonth()]} ${todaysDate.getDate()}, ${todaysDate.getFullYear()}`,
      time: `${currentTime()}`,
      company: "Softnio",
    };
    setNoteData([...noteData, submitData]);
    setAddNoteModal(false);
    setAddNoteText("");
  };

  const handleChange = async ({ target }) => {
    const { name, value } = target;
    if (name === "country") {
      try {
        let list2 = await Api.GetAdminState(value);
        if (list2 !== null) {
          setStateList(list2);
          setTenantDetail({ ...tenantDetailState, [name]: value, state: list2[0]?.stateId + " " + list2[0]?.countryId });
        } else {
          Swal.fire({
            icon: `error`,
            title: "There is No States",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: `error`,
          title: error?.message,
        });
      }
    } else {
      if (name === "zip") {
        if (value?.length <= 5) {
          setTenantDetail({ ...tenantDetailState, [name]: value });
        }
      } else {
        setTenantDetail({ ...tenantDetailState, [name]: value });
      }
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    let errors = cloneDeep(error);
    Object.keys(tenantDetailState).forEach((key) => {
      const value = tenantDetailState[key];
      switch (key) {
        case "name":
        case "organizationName":
        case "contactName":
        case "firstName":
        case "lastName":
        case "middleName":
        case "city":
          if (!(regexs?.name)?.test(value)) {
            errors[key] = `Enter Valid ${key}`;
          } else {
            errors[key] = "";
          }
          break;
        case "streetAddress":
          if (!regexs.streetAddress.test(value)) {
            errors[key] = `Enter Valid ${key}`;
          } else {
            errors[key] = "";
          }
          break;
        case "zip":
          if (!regexs.zip.test(value)) {
            errors[key] = "Enter Valid Zip code";
          } else {
            errors[key] = "";
          }
          break;
        case "emailId":
          if (!regexs.email.test(value)) {
            errors[key] = "Enter Valid Email";
          } else {
            errors[key] = "";
          }
          break;
        case "phoneNo":
          if (!usaNumRegex.test(value)) {
            errors[key] = "Enter Valid Number";
          } else {
            errors[key] = "";
          }
          break;
        case "hostIp":
          if (!ipPattern.test(value)) {
            errors[key] = "Enter Valid Host Ip";
          } else {
            errors[key] = "";
          }
          break;
        case "hostUrl":
          if (!domainPattern.test(value)) {
            errors[key] = "Enter Valid Host Url";
          } else {
            errors[key] = "";
          }
          break;
        default:
          break;
      }
    });
    errors.somethingWentWring = "";

    if (Object.values(errors).every(value => value === "")) {
      let data = cloneDeep(tenantDetailState);
      data.phoneNo = "+1" + data?.phoneNo;
      data.tenantPhone[0].phoneNo = data?.phoneNo;
      data.tenantHost[0].hostIp = data?.hostIp;
      data.tenantHost[0].hostUrl = data?.hostUrl;
      try {
        let response = await Api.InsertTenant(data);
        if (response?.data?.statusCode === 200) {
          Swal?.fire({
            icon: response?.data?.statusCode === 200 ? "success" : "error",
            title: response?.data?.statusCode === 200 ? "Tenant Added Successfully" : "Something Went Wrong",
          });
          history?.push("/Tenant/Accounts/manage-tenant")
        } else {
          errors.somethingWentWring = "Something Went Wrong";
        }
        // setTenantDetail(tenantAddEditData);
      } catch (error) {
        errors.somethingWentWring = "Something Went Wrong";
      }
    }

    setError(errors);
  }
  return (
    <React.Fragment>
      <Head title="User Details - Regular"></Head>
      {user && (
        <Content>
          <BlockHead size="sm">
            <BlockBetween>
              <BlockHeadContent>
                <BlockTitle tag="h3" page>
                  Add Tenant Detail
                </BlockTitle>
              </BlockHeadContent>
              <BlockHeadContent>
                <Button
                  color="light"
                  outline
                  className="bg-white d-none d-sm-inline-flex"
                  onClick={() => history.goBack()}
                >
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
                <a
                  href="#back"
                  onClick={(ev) => {
                    ev.preventDefault();
                    history.goBack();
                  }}
                  className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
                >
                  <Icon name="arrow-left"></Icon>
                </a>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
          <Block>
            <Card className="card-bordered">
              <div className="card-aside-wrap" id="user-detail-block">
                <div className="card-content">
                  <div className="card-inner">
                    <Block>
                      <form>
                        <Row className="mb-3">
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="first-name">
                                Name
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="name" value={tenantDetailState?.name} className="form-control bg-blue-dim" type="text" id="first-name" />
                                {error.name !== "" && <span className="invalid">{error?.name}</span>}
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="middle-name">
                                Org Name
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="organizationName" value={tenantDetailState?.organizationName} className="form-control bg-blue-dim" type="text" id="middle-name" />
                                {error.organizationName !== "" && <span className="invalid">{error?.organizationName}</span>}
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="last-name">
                                Contact Name
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="contactName" value={tenantDetailState?.contactName} className="form-control bg-blue-dim" type="text" id="last-name" />
                                {error.contactName !== "" && <span className="invalid">{error?.contactName}</span>}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="first-name">
                                First Name
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="firstName" value={tenantDetailState?.firstName} className="form-control bg-blue-dim" type="text" id="first-name" />
                                {error.firstName !== "" && <span className="invalid">{error?.firstName}</span>}
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="middle-name">
                                Middle Name
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="middleName" value={tenantDetailState?.middleName} className="form-control bg-blue-dim" type="text" id="middle-name" />
                                {error.middleName !== "" && <span className="invalid">{error?.middleName}</span>}
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="middle-name">
                                Last Name
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="lastName" value={tenantDetailState?.lastName} className="form-control bg-blue-dim" type="text" id="middle-name" />
                                {error.lastName !== "" && <span className="invalid">{error?.lastName}</span>}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="first-name">
                                Street Address
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="streetAddress" value={tenantDetailState?.streetAddress} className="form-control bg-blue-dim" type="text" id="first-name" />
                                {error.streetAddress !== "" && <span className="invalid">{error?.streetAddress}</span>}
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="middle-name">
                                City
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="city" value={tenantDetailState?.city} className="form-control bg-blue-dim" type="text" id="middle-name" />
                                {error.city !== "" && <span className="invalid">{error?.city}</span>}
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="last-name">
                                Country
                              </Label>
                              <div className="form-control-wrap">
                                <div className="form-control-select">
                                  <select
                                    onChange={handleChange} name="country"
                                    value={tenantDetailState?.country}
                                    defaultValue={tenantDetailState?.country}
                                    className="form-control form-select bg-blue-dim"
                                    id="fv-topics"
                                    placeholder="Select a option"
                                    disabled
                                  >
                                    {
                                      countryList?.map((ele, ind) => {
                                        return <option label={ele?.countryName} value={ele?.countryId} key={ind}></option>
                                      })
                                    }
                                  </select>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="first-name">
                                State
                              </Label>
                              <div className="form-control-wrap">
                                <div className="form-control-select">
                                  <select
                                    onChange={handleChange} name="state"
                                    value={tenantDetailState?.state}
                                    className="form-control form-select bg-blue-dim"
                                    id="fv-topics"
                                    placeholder="Select a option"
                                  >
                                    {
                                      stateList?.map((ele, ind) => {
                                        return <option label={ele?.stateName} value={ele?.stateId + " " + ele?.countryId} key={ind}></option>
                                      })
                                    }
                                  </select>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="middle-name">
                                Zip
                              </Label>
                              <div className="form-control-wrap">
                                <InputMask
                                  onChange={handleChange}
                                  value={tenantDetailState?.zip}
                                  name="zip"
                                  mask='99999'
                                  className="form-control bg-blue-dim"
                                  placeholder="99999"
                                  autoComplete="zip"
                                  type="text"
                                >
                                </InputMask>
                                {/* <input
                                  onChange={handleChange}
                                  name="zip"
                                  maxLength={5}
                                  value={tenantDetailState?.zip}
                                  className="form-control bg-blue-dim"
                                  type="number"
                                  id="middle-name"
                                /> */}
                                {error.zip !== "" && <span className="invalid">{error?.zip}</span>}
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="first-name">
                                Email ID
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="emailId" value={tenantDetailState?.emailId} className="form-control bg-blue-dim" type="text" id="first-name" />
                                {error.emailId !== "" && <span className="invalid">{error?.emailId}</span>}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="middle-name">
                                Time Zone
                              </Label>
                              <div className="form-control-wrap">
                                <div className="form-control-select">
                                  <select
                                    className="form-control form-select bg-blue-dim"
                                    id="fv-topics"
                                    name="timeZone"
                                    value={tenantDetailState?.timeZone}
                                    placeholder="Select a option"
                                    onChange={handleChange}
                                  >
                                    {timezones.map((timezone, index) => (
                                      <option key={index} value={timezone}>{timezone}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="fv-topics">
                                PhoneType
                              </Label>
                              <div className="form-control-wrap">
                                <div className="form-control-select">
                                  <select
                                    className="form-control form-select bg-blue-dim"
                                    id="fv-topics"
                                    name="PhoneType"
                                    placeholder="Select a option"
                                    onChange={handleChange}
                                    value={tenantDetailState?.PhoneType}
                                  >
                                    <option label="Home" value="Home"></option>
                                    <option label="Office" value="Office"></option>
                                    <option label="Cell" value="Cell"></option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="fv-topics">
                                Phone Number
                              </Label>
                              <div className="form-control-wrap">
                                <InputMask
                                  onChange={handleChange}
                                  value={tenantDetailState?.phoneNo}
                                  name="phoneNo"
                                  mask='(999) 999-9999'
                                  className="form-control bg-blue-dim"
                                  placeholder="(999) 999-9999"
                                  autoComplete="phone"
                                  type="text"
                                >
                                </InputMask>
                                {error.phoneNo !== "" && <span className="invalid">{error?.phoneNo}</span>}
                                {/* <input onChange={handleChange} name="phoneNo" value={tenantDetailState.phoneNo} className="form-control bg-blue-dim" type="text" id="first-name" /> */}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="first-name">
                                Host
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="hostUrl" value={tenantDetailState?.hostUrl} className="form-control bg-blue-dim" type="text" id="first-name" />
                                {error.hostUrl !== "" && <span className="invalid">{error?.hostUrl}</span>}
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="form-group">
                              <Label className="form-label" htmlFor="middle-name">
                                Host Ip
                              </Label>
                              <div className="form-control-wrap">
                                <input onChange={handleChange} name="hostIp" value={tenantDetailState?.hostIp} className="form-control bg-blue-dim" type="text" id="first-name" />
                                {error.hostIp !== "" && <span className="invalid">{error?.hostIp}</span>}
                                {error.somethingWentWring !== "" && <span className="invalid">{error?.somethingWentWring}</span>}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <div className="justify-end">
                          <Button onClick={onSave} color="primary" className="me-3">Save</Button>
                        </div>
                      </form>
                    </Block>
                  </div>
                </div>
              </div>
            </Card>
          </Block>
        </Content>
      )}
    </React.Fragment>
  );
};
export default AddTenant;
